import { useSelector } from 'react-redux';
import { selectors as authSelectors } from 'services/auth';
import { INSI_BYPASS_PSC_GATE } from 'config';

/**
 * Gate hook for every INSi entry point.
 *
 * Returns `true` only when BOTH gates are satisfied:
 *  - the current workspace has the INSi feature enabled (`authSelectors.getIsINS`)
 *  - the user is authenticated via Pro Santé Connect (`authSelectors.isPSCSession`)
 *
 * Both inputs already exist client-side in the auth slice, so this performs no
 * network calls. The backend still enforces both gates; this hook only hides
 * actions that would otherwise fail.
 *
 * Development escape hatch: when `INSI_BYPASS_PSC_GATE` is set
 * (`REACT_APP_INSI_BYPASS_PSC_GATE=true`), the PSC requirement is ignored so
 * the INSi UI can be exercised on a Cognito-only workspace. The backend still
 * enforces PSC, so live mutations may still be rejected — see config.ts.
 */
export const useInsiAccess = (): boolean => {
  const isInsWorkspace = useSelector(authSelectors.getIsINS);
  const isPsc = useSelector(authSelectors.isPSCSession);

  return Boolean(isInsWorkspace && (isPsc || INSI_BYPASS_PSC_GATE));
};
